export const nlsAnalyticsQueryKeys = {
  all: ['nls-analytics'] as const,
  category2Queries: (limit: number, offset: number) =>
    [...nlsAnalyticsQueryKeys.all, 'category-2-queries', { limit, offset }] as const,
  category3Queries: (limit: number, offset: number) =>
    [...nlsAnalyticsQueryKeys.all, 'category-3-queries', { limit, offset }] as const,
};
